import React from 'react';
import { Star } from 'lucide-react';

export default function ContactCTA() {
  return (
    <div className="bg-secondary-light py-20">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-primary mb-6">
          ¿Quieres ser patrocinador?
        </h2>
        <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
          Únete a nuestro concurso y forma parte de esta mágica experiencia navideña.
          Contáctanos para conocer los diferentes paquetes de patrocinio disponibles.
        </p>
        <a 
          href="mailto:hola@iznoval.com"
          className="inline-flex items-center bg-primary hover:bg-primary-dark text-white px-8 py-3 rounded-lg transition-colors"
        >
          <Star className="h-5 w-5 mr-2" />
          Contactar para Patrocinio
        </a>
      </div>
    </div>
  );
}